
import React, { useState, useEffect } from 'react';

import { FungibleTokenMetaData, ONE_ALPH, addressFromContractId, hexToString, prettifyAttoAlphAmount, prettifyTokenAmount, stringToHex, waitForTxConfirmation, web3 } from '@alephium/web3';
import { AlephiumConnectButton, useWallet } from '@alephium/web3-react';
import './RocketRangeMobile.css'
import { getContractConfig } from '../../../services/utils';
import RocketRangeCurrentRound from '../RocketRangeCurrentRound';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faPlay, faTrophy, faUser, faVoteYea } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';

export default function RocketRangeMobile() {
  const location = useLocation();
  const navigate = useNavigate();

  const renderTabContent = () => {
    switch (activeTab) {
      case "Vote":
        return <RocketRangeCurrentRound />;
      default:
        return null;
    }
  };

  const tabs = [
    { label: "Vote", icon: faVoteYea },
  ];

  // Parse the initial tab from the URL
  const initialTab = new URLSearchParams(location.search).get("tab") || "Vote";
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTabChange = (tabLabel: string) => {
    setActiveTab(tabLabel);
    navigate(`?tab=${tabLabel}`);
  };

  return (
    <div className="w-full max-w-4xl mx-auto bg-gray-950 text-white rounded-lg shadow-md">
      {/* Tabs Navigation */}
      <div className="flex border-b border-gray-800 justify-around">
        {tabs.map((tab) => (
          <div className="relative group flex-1" key={tab.label}>
            <button
              className={`flex items-center justify-center w-full h-16 transition-all duration-300 ${activeTab === tab.label
                ? "bg-gray-900 text-red-500 border-b-2 border-red-500"
                : "hover:bg-gray-900 hover:text-red-500"
                }`}
              onClick={() => handleTabChange(tab.label)}
            >
              <FontAwesomeIcon icon={tab.icon} className="text-lg" />
            </button>
            {/* Tooltip */}
            <span className="absolute bottom-12 left-1/2 transform -translate-x-1/2 px-2 py-1 w-[100px] text-center text-xs text-white bg-black rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
              {tab.label}
            </span>
          </div>
        ))}
      </div>

      {/* Tab Content */}
      <div>{renderTabContent()}</div>
    </div>
  );
}


